import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  page: {
    backgroundColor: '#f8fafc',
    color: '#172033',
    paddingBottom: { xs: '76px', md: 0 },
  },
  container: {
    width: '100%',
    maxWidth: '1280px',
    margin: '0 auto',
    padding: { xs: '0 18px', md: '0 36px' },
  },
  hero: {
    backgroundColor: '#fff',
    padding: { xs: '22px 0 34px', md: '30px 0 42px' },
  },
  breadcrumb: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: '#64748b',
    fontSize: '12px',
    marginBottom: { xs: '24px', md: '34px' },
    overflow: 'hidden',
    '& a, & p': {
      color: 'inherit',
      fontSize: '12px',
      whiteSpace: 'nowrap',
    },
  },
  breadcrumbCurrent: {
    color: '#172033',
    fontWeight: 700,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  heroGrid: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      lg: 'minmax(0, 7fr) minmax(360px, 5fr)',
    },
    gap: { xs: '30px', lg: '32px' },
    alignItems: 'start',
  },
  heroContent: { minWidth: 0 },
  badges: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: '16px',
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '7px 12px',
    borderRadius: '999px',
    backgroundColor: '#f3e5f5',
    border: '1px solid rgba(194, 24, 91, .2)',
    color: '#aa1d5d',
    fontSize: '12px',
    fontWeight: 700,
    '& svg': { width: '16px', height: '16px' },
  },
  locationBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '7px 12px',
    borderRadius: '999px',
    backgroundColor: '#e6f5f7',
    color: '#00687a',
    fontSize: '12px',
    fontWeight: 700,
    border: '1px solid #d9e4e8',
    '& span': {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: '#10b981',
    },
  },
  title: {
    fontSize: { xs: '30px', sm: '36px', md: '40px' },
    lineHeight: 1.12,
    letterSpacing: '-0.035em',
    fontWeight: 800,
    color: '#172033',
    marginBottom: '18px',
  },
  pageMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px 18px',
    margin: '-8px 0 16px',
    color: '#64748b',
    '& p': { fontSize: '12px', fontWeight: 600 },
  },
  heroDescription: {
    color: '#526174',
    fontSize: { xs: '15px', md: '17px' },
    lineHeight: 1.72,
    maxWidth: '760px',
    '& p': { margin: '0 0 10px' },
  },
  reviewCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '13px 14px',
    marginTop: '18px',
    borderRadius: '14px',
    border: '1px solid #e2e8f0',
    backgroundColor: '#f8fafc',
    boxShadow: '0 2px 8px rgba(15, 23, 42, .04)',
  },
  reviewIcon: {
    width: '42px',
    height: '42px',
    flexShrink: 0,
    display: 'grid',
    placeItems: 'center',
    borderRadius: '50%',
    backgroundColor: '#e8f7f3',
    color: '#078277',
    '& svg': { width: '23px', height: '23px' },
  },
  reviewerImage: {
    width: '44px',
    height: '44px',
    flexShrink: 0,
    borderRadius: '50%',
    objectFit: 'cover',
    border: '2px solid #fff',
    boxShadow: '0 2px 8px rgba(15, 23, 42, .12)',
  },
  reviewTitle: { color: '#172033', fontSize: '14px', fontWeight: 800 },
  reviewCopy: { color: '#64748b', fontSize: '12px', marginTop: '2px' },
  factsGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
    gap: '12px',
    marginTop: '24px',
  },
  factCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '13px',
    padding: '14px',
    border: '1px solid #dbe8ee',
    borderRadius: '12px',
    backgroundColor: 'rgba(216, 231, 238, .3)',
  },
  factIcon: {
    width: '40px',
    height: '40px',
    borderRadius: '10px',
    backgroundColor: '#fff',
    color: '#b01f62',
    display: 'grid',
    placeItems: 'center',
    boxShadow: '0 4px 16px rgba(15, 23, 42, .07)',
    '& svg': { width: '21px', height: '21px' },
  },
  factLabel: {
    color: '#738092',
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '.05em',
    fontWeight: 700,
  },
  factValue: { color: '#172033', fontSize: '14px', fontWeight: 700 },
  prerequisite: {
    display: 'flex',
    gap: '10px',
    alignItems: 'flex-start',
    marginTop: '16px',
    padding: '14px 16px',
    borderRadius: '12px',
    backgroundColor: '#e7f6f2',
    border: '1px solid #b9e3d7',
    color: '#254c47',
    '& svg': { width: '20px', height: '20px', flexShrink: 0 },
    '& p': { fontSize: '13px', lineHeight: 1.55 },
  },
  priceColumn: { position: { lg: 'sticky' }, top: { lg: '126px' } },
  genericBookingCard: {
    padding: { xs: '22px', md: '26px' },
    border: '2px solid #e2e8f0',
    borderRadius: '14px',
    backgroundColor: '#fff',
    boxShadow: '0 18px 48px rgba(15, 23, 42, .12)',
  },
  genericBookingEyebrow: {
    color: '#078277',
    fontSize: '11px',
    fontWeight: 800,
    letterSpacing: '.12em',
  },
  genericBookingTitle: {
    marginTop: '7px',
    color: '#172033',
    fontSize: '20px',
    lineHeight: 1.35,
    fontWeight: 800,
  },
  genericBookingCopy: {
    margin: '12px 0 18px',
    color: '#667386',
    fontSize: '13px',
    lineHeight: 1.55,
  },
  genericBookButton: {
    minHeight: '48px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    backgroundColor: '#b01f62',
    fontSize: '15px',
    fontWeight: 800,
    textDecoration: 'none',
  },
  priceCard: {
    width: '100%',
    border: '2px solid #e2e8f0',
    borderRadius: '16px',
    padding: { xs: '20px', md: '26px' },
    boxShadow: '0 18px 48px rgba(15, 23, 42, .12)',
  },
  priceCardInner: { width: '100%', padding: 0 },
  priceHeading: { fontSize: '19px', lineHeight: 1.35 },
  priceValue: { fontSize: '30px', fontWeight: 800 },
  bookButton: {
    width: '100%',
    minHeight: '48px',
    borderRadius: '10px',
    fontSize: '15px',
    fontWeight: 700,
    backgroundColor: '#b01f62',
    '&:hover': { backgroundColor: '#94174f' },
  },
  mobileCartAction: {
    position: { xs: 'fixed', md: 'static' },
    left: { xs: 0 },
    bottom: { xs: 0 },
    zIndex: { xs: 1200 },
    width: { xs: '50%', md: '100%' },
    minHeight: { xs: '72px', md: 'auto' },
    padding: { xs: '12px 6px 12px 12px', md: 0 },
    alignItems: 'center',
    backgroundColor: { xs: '#fff', md: 'transparent' },
    boxShadow: { xs: '0 -4px 18px rgba(15, 23, 42, .14)', md: 'none' },
  },
  assuranceList: {
    padding: '18px 22px',
    backgroundColor: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: '16px',
    marginTop: '16px',
  },
  assuranceItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    marginTop: '9px',
    color: '#475569',
    '& svg': { width: '17px', height: '17px', color: '#078277' },
    '& p': { fontSize: '12px', fontWeight: 600 },
  },
  callButton: {
    minHeight: '48px',
    marginTop: { xs: 0, md: '12px' },
    position: { xs: 'fixed', md: 'static' },
    right: { xs: 0 },
    bottom: { xs: 0 },
    zIndex: { xs: 1200 },
    width: { xs: '50%', md: 'auto' },
    height: { xs: '72px', md: 'auto' },
    padding: { xs: '12px 12px 12px 6px', md: 0 },
    border: { xs: '12px solid #fff', md: '2px solid #078277' },
    borderLeftWidth: { xs: '6px', md: '2px' },
    borderRadius: { xs: 0, md: '10px' },
    color: { xs: '#fff', md: '#078277' },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontSize: '15px',
    fontWeight: 800,
    textDecoration: 'none',
    backgroundColor: { xs: '#078277', md: '#fff' },
    boxShadow: { xs: '0 -4px 18px rgba(15, 23, 42, .14)', md: 'none' },
    '& svg': { width: '20px', height: '20px' },
    '&:hover': { color: '#fff', backgroundColor: '#078277' },
  },
  sampleReportButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '44px',
    marginTop: '12px',
    border: '1px dashed #94a3b8',
    borderRadius: '10px',
    color: '#475569',
    backgroundColor: '#fff',
    fontSize: '13px',
    fontWeight: 700,
    textDecoration: 'none',
    '&:hover': { borderColor: '#078277', color: '#078277' },
  },
  offersSection: {
    padding: '28px 0',
    background:
      'linear-gradient(90deg, rgba(194, 24, 91, .12), rgba(16, 185, 129, .08), rgba(194, 24, 91, .12))',
    borderTop: '1px solid rgba(194, 24, 91, .15)',
    borderBottom: '1px solid rgba(194, 24, 91, .15)',
  },
  offersGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
    gap: '14px',
  },
  offerCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '13px',
    padding: '17px',
    borderRadius: '14px',
    border: '1px solid rgba(194, 24, 91, .15)',
    backgroundColor: '#fff',
    boxShadow: '0 6px 18px rgba(15, 23, 42, .06)',
  },
  offerIcon: {
    width: '42px',
    height: '42px',
    flexShrink: 0,
    display: 'grid',
    placeItems: 'center',
    borderRadius: '12px',
    backgroundColor: '#f3e5f5',
    color: '#b01f62',
    '& svg': { width: '22px', height: '22px' },
  },
  offerTitle: { color: '#172033', fontSize: '14px', fontWeight: 800 },
  offerCopy: {
    color: '#64748b',
    fontSize: '12px',
    lineHeight: 1.45,
    marginTop: '3px',
  },
  trustSection: {
    padding: { xs: '34px 0', md: '46px 0' },
    backgroundColor: 'rgba(213, 213, 213, .3)',
    borderTop: '1px solid #d5e0e5',
    borderBottom: '1px solid #d5e0e5',
  },
  trustHeading: { textAlign: 'center', marginBottom: '24px' },
  trustGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(5, 1fr)' },
    gap: '12px',
  },
  trustItem: {
    textAlign: 'center',
    padding: '20px 12px',
    border: '1px solid #e2e8f0',
    borderRadius: '14px',
    backgroundColor: '#fff',
    boxShadow: '0 4px 14px rgba(15, 23, 42, .04)',
  },
  trustValue: {
    color: '#00687a',
    fontSize: { xs: '19px', md: '23px' },
    fontWeight: 800,
  },
  trustLabel: { color: '#5c6878', fontSize: '12px', fontWeight: 600 },
  contentSection: {
    padding: { xs: '34px 0 54px', md: '44px 0 76px' },
    backgroundColor: '#fff',
  },
  contentCard: {
    padding: { xs: '20px', md: '30px' },
    backgroundColor: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: '16px',
    marginBottom: '28px',
    boxShadow: '0 8px 30px rgba(15, 23, 42, .05)',
  },
  sectionHeading: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    marginBottom: '22px',
  },
  sectionIcon: {
    width: '46px',
    height: '46px',
    borderRadius: '12px',
    display: 'grid',
    placeItems: 'center',
    backgroundColor: '#e6f5f7',
    color: '#00687a',
    '& svg': { width: '25px' },
  },
  sectionTitle: {
    color: '#172033',
    fontSize: { xs: '21px', md: '27px' },
    lineHeight: 1.25,
    fontWeight: 800,
  },
  sectionSubtitle: { color: '#718096', fontSize: '13px', marginTop: '3px' },
  accordionList: { display: 'flex', flexDirection: 'column', gap: '10px' },
  accordionToggle: {
    boxShadow: 'none',
    border: '1px solid #e2e8f0',
    minHeight: '52px',
    borderRadius: '10px',
  },
  parameterList: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
    gap: '9px 24px',
    padding: '12px 22px 8px',
    '& li': { color: '#4f5d6d', fontSize: '14px', lineHeight: 1.5 },
  },
  guideGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: '300px minmax(0, 1fr)' },
    gap: '0',
    backgroundColor: 'rgba(216, 231, 238, .22)',
    border: '1px solid #d7e3e9',
    borderRadius: '16px',
    overflow: 'hidden',
    marginBottom: '28px',
  },
  guideAside: {
    padding: { xs: '24px', md: '32px' },
    backgroundColor: '#00687a',
    color: '#fff',
  },
  asideEyebrow: {
    fontSize: '11px',
    letterSpacing: '.14em',
    fontWeight: 800,
    opacity: 0.78,
  },
  asideTitle: {
    fontSize: '25px',
    lineHeight: 1.25,
    fontWeight: 800,
    marginTop: '10px',
  },
  asideCopy: {
    fontSize: '13px',
    lineHeight: 1.65,
    opacity: 0.88,
    marginTop: '14px',
  },
  guideContent: { padding: { xs: '22px', md: '34px' }, minWidth: 0 },
  medicalContent: {
    color: '#4f5d6d',
    fontSize: '15px',
    lineHeight: 1.75,
    '& h2, & h3, & h4': {
      color: '#172033',
      fontWeight: 800,
      margin: '18px 0 9px',
    },
    '& p': { margin: '0 0 13px' },
    '& ul, & ol': { paddingLeft: '22px' },
    '& li': { marginBottom: '7px' },
  },
  readMoreButton: {
    marginTop: '16px',
    padding: '10px 17px',
    border: '1px solid #00687a',
    borderRadius: '9px',
    backgroundColor: '#fff',
    color: '#00687a',
    fontWeight: 700,
    cursor: 'pointer',
  },
  whyApollo: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '18px',
    padding: { xs: '22px', md: '30px' },
    borderRadius: '16px',
    backgroundColor: '#e7f6f2',
    border: '1px solid #b9e3d7',
    '& > svg': {
      color: '#007d71',
      width: '30px',
      height: '30px',
      flexShrink: 0,
    },
  },
  whyApolloCopy: {
    color: '#45605c',
    fontSize: '14px',
    lineHeight: 1.7,
    marginTop: '10px',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>
export default styles
